<template>
  <div style="padding:20px;">
    <p>
      <span style="font-family: 微软雅黑, Microsoft YaHei;"><strong><span style="text-wrap: nowrap;">Privacy
            Policy</span></strong></span>
    </p>
    <p>
      <span style="font-family: 微软雅黑, Microsoft YaHei;"><strong><span
            style="font-family: 微软雅黑, Microsoft YaHei; text-wrap: nowrap;">Introduction</span></strong></span>
    </p>
    <p>
      <span style="font-family: 微软雅黑, Microsoft YaHei;">We value your privacy and are committed to protecting your
        personal information. This Privacy Policy outlines how we collect, use, and share your personal information when
        you use our lifestyle service app. By using our app, you consent to the collection, use, and sharing of your
        personal information as described in this Privacy Policy.</span>
    </p>
    <p>
      <strong><span style="font-family: 微软雅黑, Microsoft YaHei;">Collection of Personal Information</span></strong>
    </p>
    <p>
      <span style="font-family: 微软雅黑, Microsoft YaHei;">We may collect personal information about you in several ways,
        including but not limited to:</span>
    </p>
    <p>
      <span style="font-family: 微软雅黑, Microsoft YaHei;">&nbsp; &nbsp; Information you provide us directly, such as your
        name, email address, and other contact details.</span>
    </p>
    <p>
      <span style="font-family: 微软雅黑, Microsoft YaHei;">&nbsp; &nbsp; Information automatically collected when you use
        our app, such as device information, usage data, and location information (if enabled).</span>
    </p>
    <p>
      <strong><span style="font-family: 微软雅黑, Microsoft YaHei;">Use of Personal Information</span></strong>
    </p>
    <p>
      <span style="font-family: 微软雅黑, Microsoft YaHei;"><span
          style="font-family: 微软雅黑, Microsoft YaHei; text-wrap: nowrap;">We use your personal information for the
          following purposes:</span></span>
    </p>
    <p>
      <span style="font-family: 微软雅黑, Microsoft YaHei;">&nbsp; &nbsp; To provide you with the services and features of
        our app.</span>
    </p>
    <p>
      <span style="font-family: 微软雅黑, Microsoft YaHei;">&nbsp; &nbsp; To improve our app and customize your
        experience.</span>
    </p>
    <p>
      <span style="font-family: 微软雅黑, Microsoft YaHei;">&nbsp; &nbsp; To communicate with you about our app, including
        updates, promotions, and other relevant information.</span>
    </p>
    <p>
      <span style="font-family: 微软雅黑, Microsoft YaHei;">&nbsp; &nbsp; To comply with legal obligations and protect our
        rights and interests.</span>
    </p>
    <p>
      <strong><span style="font-family: 微软雅黑, Microsoft YaHei;">Sharing of Personal Information</span></strong>
    </p>
    <p>
      <span style="font-family: 微软雅黑, Microsoft YaHei;">We may share your personal information with third parties in the
        following circumstances:</span>
    </p>
    <p>
      <span style="font-family: 微软雅黑, Microsoft YaHei;">&nbsp; &nbsp; With service providers who assist us in operating
        and improving our app.</span>
    </p>
    <p>
      <span style="font-family: 微软雅黑, Microsoft YaHei;">&nbsp; &nbsp; In response to legal requirements or to protect
        our rights and interests.</span>
    </p>
    <p>
      <span style="font-family: 微软雅黑, Microsoft YaHei;">&nbsp; &nbsp; With your consent or as otherwise permitted by
        law.</span>
    </p>
    <p>
      <strong><span style="font-family: 微软雅黑, Microsoft YaHei;">Security of Personal Information</span></strong>
    </p>
    <p>
      <span style="font-family: 微软雅黑, Microsoft YaHei;">We take reasonable measures to protect your personal information
        from unauthorized access, use, disclosure, or destruction. However, no method of transmission over the internet
        or method of electronic storage is completely secure, and we cannot guarantee the absolute security of your
        personal information.</span>
    </p>
    <p>
      <strong><span style="font-family: 微软雅黑, Microsoft YaHei;">Your Rights</span></strong>
    </p>
    <p>
      <span style="font-family: 微软雅黑, Microsoft YaHei;">You have the right to access, correct, or delete your personal
        information held by us. You may also opt out of receiving certain communications from us. To exercise these
        rights or for any other privacy-related inquiries, please contact us at [email address or contact form].</span>
    </p>
    <p>
      <strong><span style="font-family: 微软雅黑, Microsoft YaHei;">Changes to Privacy Policy</span></strong>
    </p>
    <p>
      <span style="font-family: 微软雅黑, Microsoft YaHei;">We may update this Privacy Policy from time to time to reflect
        changes in our practices or legal requirements. We will notify you of any significant changes by posting a
        notice on our app or by other means. It is your responsibility to review this Privacy Policy periodically for
        updates.</span>
    </p>
    <p>
      <span style="font-family: 微软雅黑, Microsoft YaHei;">By using our lifestyle service app, you agree to the terms of
        this Privacy Policy. If you have any questions or concerns about our privacy practices, please feel free to
        contact us. We are committed to protecting your privacy and providing you with a secure and enjoyable
        experience.</span>
    </p>
    <p>
      <span style="font-family: 微软雅黑, Microsoft YaHei;">Thank you for using our app and for entrusting us with your
        personal information. We value your trust and will continue to strive to protect your privacy.</span>
    </p>
  </div>
</template>
<script>
/**
 * Created by www.xingnuocn.com
 * @title：
 * @author: 刘嘉鑫 
 * @version  V1.0 
 * @datecreate: 2024-04-03 15:45
 */
export default {
  data() {
    return {};
  },
  mounted() { },
  methods: {},
};
</script>
<style lang='scss' scoped>
span,
p,
div {
  font-size: 30px;
  color: #222222;
  text-align: left;
}
</style>